export const PHONE_DISPLAY = "405-655-9536";
export const PHONE_TEL = "tel:4056559536";
export const PHONE_SMS = "sms:4056559536";

export const AVAILABILITY = [
  { days: "Wednesdays", hours: "from 4:30 PM" },
  { days: "Saturday & Sunday", hours: "7:00 AM – 6:00 PM" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1608259243654-70c070e0f6ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZyUyMGNsZWFuJTIwbGVhdGhlciUyMHNlYXRzfGVufDB8fHx8MTc4OTUzNDMzNnww&ixlib=rb-4.1.0&q=85",
  leather: "https://images.unsplash.com/photo-1616196334411-1d8d09708ca6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZyUyMGNsZWFuJTIwbGVhdGhlciUyMHNlYXRzfGVufDB8fHx8MTc4OTUzNDMzNnww&ixlib=rb-4.1.0&q=85",
  wipe: "https://images.unsplash.com/photo-1732357624591-f2137085659b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZyUyMGNsZWFuJTIwbGVhdGhlciUyMHNlYXRzfGVufDB8fHx8MTc4OTUzNDMzNnww&ixlib=rb-4.1.0&q=85",
  detailer: "https://images.pexels.com/photos/31389821/pexels-photo-31389821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TIERS = [
  {
    id: "basic",
    name: "Basic Clean",
    price: 60,
    tagline: "Essential interior maintenance & freshening",
    popular: false,
    features: [
      "Full interior vacuuming (seats, carpets, floor mats)",
      "Dash, center console & door panel wipe-down",
      "Interior glass & mirror streak-free cleaning",
      "Door jambs wiped & cleaned",
      "Fresh cabin air scent treatment",
    ],
  },
  {
    id: "premium",
    name: "Premium Clean",
    price: 80,
    tagline: "Deep restoration, stain spot-removal & leather care",
    popular: true,
    features: [
      "Everything in Basic Clean, plus:",
      "Deep carpet & upholstery spot stain extraction",
      "Leather seat cleaning & deep conditioning",
      "High-pressure air blowout for seams & crevices",
      "Trunk space vacuumed & detailed",
      "UV protective dressing on all vinyl/plastic surfaces",
    ],
  },
];
